import { http } from '@/services';

export default {
  getProfileList: async function() {
    try {
      return await http.get('perfil/');
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
  getPlanList: async function() {
    try {
      return await http.get('plano/');
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
};
